import React from "react";
import iconWinner from "../../../../../assets/images/Event-2025/icon-winner.png";
import styled from "styled-components";
import iconTe from "../../../../../assets/images/Event-2025/icon-te.png";
import iconSung from "../../../../../assets/images/Event-2025/icon-sung.png";
import WinnerComponent from "../Winner";

function TitleLogo({ width, height, isPopup = false, logo }) {
  return (
    <Container isPopup={isPopup}>
      <img
        src={logo}
        className="title-logo"
        alt="title logo"
        width={width}
        height={height}
      />
      {!isPopup && (
        <>
          <WinnerComponent />
          <img src={iconTe} alt="" className="icon-te__collection" />
          <img src={iconSung} alt="" className="icon-sung__collection" />
        </>
      )}
    </Container>
  );
}

export default TitleLogo;

const Container = styled.div`
  position: relative;
  margin-bottom: ${(props) => (props.isPopup ? "0" : "85px")};

  .icon-winner__collect {
    position: absolute;
    bottom: -85px;
    left: 0;
    cursor: pointer;
    z-index: 3;
  }

  .icon-te__collection {
    position: absolute;
    left: -90px;
    z-index: 1;
    bottom: -190px;
    pointer-events: none;
  }

  .title-logo {
    display: block;
    margin: 0 auto;
    position: relative;
    z-index: 2;
    padding: 0 30px;
    margin-top: 10px;
    margin-bottom: 5px;
  }

  .icon-sung__collection {
    position: absolute;
    right: -70px;
    z-index: 1;
    bottom: -173px;
    pointer-events: none;
  }

  @media (max-width: 576px) {
    .title-logo {
      margin-top: 5px;
    }

    .icon-winner__collect {
      width: 74px;
    }

    .icon-te__collection {
      width: 192px;
      left: -60px;
      bottom: -85px;
    }

    .icon-sung__collection {
      right: -50px;
      width: 210px;
      bottom: -80px;
    }

    margin-bottom: ${(props) => (props.isPopup ? "0" : "70px")};
  }
`;
